import {Component} from 'react';
import {generatePath, RouteComponentProps} from 'react-router';
import {loadBooking} from 'services/bookings';
import {convertDraftBooking, saveDraftBooking} from 'services/bookings/drafts';
import RouteURLs from 'RouteURLs';

interface RebookPageProps extends RouteComponentProps<{code: string}> {
}

export default class RebookPage extends Component<RebookPageProps> {
  componentDidMount(): void {
    const bookingCode = this.props.match.params.code;
    loadBooking(bookingCode).then(
      booking => {
        const draftBooking = convertDraftBooking(booking);
        draftBooking.code = null;
        draftBooking.times = [];
        saveDraftBooking(draftBooking);
        this.props.history.replace(generatePath(RouteURLs.CREATE_BOOKING_TIME));
      },
      () => this.props.history.replace(RouteURLs.NOT_FOUND)
    );
  }

  render() {
    return null;
  }
}